import { render } from "./RolesList.vue?vue&type=template&id=4a230bda&scoped=true&ts=true"
import script from "./RolesList.vue?vue&type=script&lang=ts"
export * from "./RolesList.vue?vue&type=script&lang=ts"

import "./RolesList.vue?vue&type=style&index=0&id=4a230bda&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a230bda"]])

export default __exports__